import React from 'react'
import PropTypes from 'prop-types'

import ExclusionModal from 'component/Modal/ExclusionModal'
import Glyph from 'component/utils/Glyph'
import Switch from '../Switch'

const Table = ({
  handleDelete,
  openEditModal,
  records,
  toggleInInactive,
  translate,
}) => {
  const renderHeader = () => (
    <tr>
      <th>{translate('justification')}</th>
      <th>{translate('type')}</th>
      <th>{translate('status')}</th>
      <th className='text-align-center'>
        {translate('justifications.justificationEdit')}
      </th>
      <th className='text-align-center'>
        {translate('demarcate.justifies.table.header.exclude-justify')}
      </th>
    </tr>
  )

  const renderBody = () => {
    const renderRow = (record) => {
      const { dsJustification } = record
      const isActive = !record.inInactive
      const type =
        record.typeJustification === 'request'
          ? translate('demarcate.justifies.type.request')
          : translate('demarcate.justifies.type.reproval')

      return (
        <tr key={record.idJustification}>
          <td>{dsJustification}</td>
          <td>{type}</td>
          <td>
            <Switch
              checked={isActive}
              onChange={() =>
                toggleInInactive({
                  ...record,
                  inInactive: isActive ? 1 : 0,
                  isToggleUpdate: true,
                })
              }
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            {translate(
              isActive
                ? 'linear.conference.justification.active'
                : 'linear.conference.justification.inactive'
            )}
          </td>
          <td className='mission-block-edit-icon'>
            <Glyph
              type='pencil'
              color='primary'
              customClass='glyph glyph-pencil color-primary font-20 cursor-pointer'
              onClick={() => openEditModal(record)}
            />
          </td>
          <td className='mission-block-edit-icon'>
            <ExclusionModal
              confirmButtonMsg='linear.conference.justification.table.confirm.delete'
              message={
                <>
                  <br />
                  {translate(
                    'linear.conference.justification.modal.delete.question'
                  )}
                  <br />
                  <b>{record.dsJustification}</b>
                </>
              }
              onConfirm={() => handleDelete(record)}
              renderButton={({ onClick }) => (
                <Glyph
                  color='danger'
                  onClick={onClick}
                  type='trash-can'
                  customClass='glyph glyph-pencil color-primary font-20 cursor-pointer'
                />
              )}
              t={translate}
              title={translate('newSectionBlock.remove.title')}
            />
          </td>
        </tr>
      )
    }

    return records.map(renderRow)
  }

  return (
    <table cellPadding={0} cellSpacing={0} className='new-table'>
      <thead>{renderHeader()}</thead>
      <tbody>{renderBody()}</tbody>
    </table>
  )
}

Table.propTypes = {
  handleDelete: PropTypes.func,
  openEditModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  toggleInInactive: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Table
